
export class Measure {

    id: string = '';
    caption: string = '';
    description: string = '';
    columnname?: string;
    aggregationType?: string;
    filter?: string;
    factTableId?: string;

}
